import React from 'react';
import Modal from './Modal';

// 统一宽度弹窗封装：默认 900px，可通过 size 预设或直接传 overrideMaxWidth
// size: 'wide'(900) | 'xl'(1040) | 'lg'(760) | 'md'(600) | 'sm'(480)
const sizeMap = {
  wide: '900px',
  xl: '1040px',
  lg: '760px',
  md: '600px',
  sm: '480px'
};

const WideModal = ({ size='wide', maxWidth, overrideMaxWidth, ...rest }) => {
  const resolved = overrideMaxWidth || maxWidth || sizeMap[size] || sizeMap.wide;
  return <Modal {...rest} maxWidth={resolved} />;
};

export default WideModal;